import { RefData } from '../types/byRef'
import { pointers } from '@wix/thunderbolt-becky-types'

const DATA_MAPS = pointers.data.DATA_MAPS
const PROPERTY_TYPES = pointers.components.PROPERTY_TYPES
export const REF_DELIMITER = '_r_'

export const getEmptyDataMaps: () => RefData = () => ({
	[DATA_MAPS.BEHAVIORS]: {},
	[DATA_MAPS.BREAKPOINTS]: {},
	[DATA_MAPS.PROPERTIES]: {},
	[DATA_MAPS.CONNECTIONS]: {},
	[DATA_MAPS.DESIGN]: {},
	[DATA_MAPS.DATA]: {},
	[DATA_MAPS.LAYOUT]: {},
	[DATA_MAPS.MOBILE_HINTS]: {},
	[DATA_MAPS.STYLE]: {},
	[DATA_MAPS.TRANSFORMATIONS]: {},
	[DATA_MAPS.TRANSITIONS]: {},
	[DATA_MAPS.ANCHOR]: {},
	[DATA_MAPS.VARIANTS]: {},
	[DATA_MAPS.PRESETS]: {},
})

export const DATA_QUERIES_TO_INFLATE = [
	PROPERTY_TYPES.BEHAVIOR_QUERY,
	PROPERTY_TYPES.BREAKPOINTS_QUERY,
	PROPERTY_TYPES.PROPERTY_QUERY,
	PROPERTY_TYPES.CONNECTION_QUERY,
	PROPERTY_TYPES.DESIGN_QUERY,
	PROPERTY_TYPES.DATA_QUERY,
	PROPERTY_TYPES.LAYOUT_QUERY,
	PROPERTY_TYPES.MOBILE_HINTS_QUERY,
	PROPERTY_TYPES.STYLE_ID,
	PROPERTY_TYPES.TRANSFORMATION_QUERY,
	PROPERTY_TYPES.TRANSITION_QUERY,
]

export const getRefCompIdFromInflatedId = (compId: string): string => compId.split(REF_DELIMITER)[0]

export const getUniqueId = (refId: string, originalId: string) => `${refId}${REF_DELIMITER}${originalId}`

export const removeHash = (value: string) => value && value.replace('#', '')
